import { Tab } from 'foundations-components/transitional/components/Tabs';
import RouterTab from 'ui-addon-react-router-dom/RouterTab';
import { useShouldReloadLocation } from '../hooks/useShouldReloadLocation';
import { useReloadLinkProps } from '../hooks/useReloadLinkProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * App-aware drop-in for `RouterTab`. Renders a Trellis `Tab` with a full page
 * reload for cross-app navigation, or a `RouterTab` for same-app navigation.
 *
 * @param href - Optional override for the resolved href. Only used during
 *   cross-app navigation (full page reload). Has no effect for same-app
 *   navigation, where `to` is used instead.
 */
export const ACRouterTab = props => {
  const {
    href,
    handleClick
  } = useReloadLinkProps(props);
  const shouldReload = useShouldReloadLocation(props.to);
  if (shouldReload) {
    return /*#__PURE__*/_jsx(Tab, Object.assign({}, props, {
      href: href,
      onClick: handleClick
    }));
  }
  return /*#__PURE__*/_jsx(RouterTab, Object.assign({}, props, {
    href: undefined
  }));
};